import { CSSProperties } from 'react';

import { AppColors } from './../../theme';

type TimelineSlipStyles = {
  card: CSSProperties;
  cardLeft: CSSProperties;
  cardDate: CSSProperties;
  cardCenter: CSSProperties;
  cardRight: CSSProperties;
  cardLabel: CSSProperties;
  cardNumber: CSSProperties;
  cardRow: CSSProperties;
};

const styles: TimelineSlipStyles = {
  card: {
    width: '100%',
    height: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: AppColors.VA.NEUTRALS._10_,
    borderRadius: 8,
    borderColor: 'transparent',
    gap: 16,
    marginTop: '8px',
    padding: '8px 16px'
  },
  cardLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    minWidth: 0,
    width: '100%'
  },
  cardDate: {
    width: 'auto',
    height: 'auto',
    color: AppColors.VA.NEUTRALS._90_
  },
  cardCenter: {
    width: '90px',
    minWidth: '72px',
    height: '22px',
    color: AppColors.VA.NEUTRALS._90_,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1.9rem'
  },
  cardRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: '4px',
    minWidth: 0,
    width: '100%'
  },
  cardLabel: {
    minWidth: 0,
    minHeight: 22,
    color: AppColors.VA.NEUTRALS._90_,
    textAlign: 'right',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
  },
  cardNumber: {
    minWidth: 0,
    minHeight: 22,
    color: AppColors.VA.NEUTRALS._90_,
    textAlign: 'right',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
  },
  cardRow: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 0.8fr) 90px minmax(0, 1.2fr)',
    gap: '16px',
    alignItems: 'flex-start'
  }
};

export default styles;
